import type { ConfigOverride } from '#dn-types/host.ts';

/**
 * We show allow lists on multiple rows in the tag form, but the server expects a single override
 * with a record of CIDR allow rules.
 *
 * This helper function combines allow lists into the shape the API server expects.
 */
export function mergeAllowListOverrides(overrides: ConfigOverride[]): ConfigOverride[] {
  const merged: ConfigOverride[] = [];
  const remote: ConfigOverride = { key: 'lighthouse.remote_allow_list', value: {} };
  const local: ConfigOverride = { key: 'lighthouse.local_allow_list', value: { interfaces: {} } };

  for (const override of overrides) {
    if (override.key === 'lighthouse.remote_allow_list') {
      remote.value = { ...remote.value, ...override.value };
    } else if (override.key === 'lighthouse.local_allow_list') {
      const { interfaces, ...cidrs } = override.value;
      local.value = { ...local.value, interfaces: { ...local.value.interfaces, ...interfaces }, ...cidrs };
    } else {
      merged.push(override);
    }
  }

  if (Object.keys(remote.value).length) {
    merged.push(remote);
  }
  if (Object.keys(local.value.interfaces).length || Object.keys(local.value).length > 1) {
    merged.push(local);
  }

  return merged;
}
